import {
    GET_UNREAD_NOTIFICATIONS_REQUEST,
    GET_UNREAD_NOTIFICATIONS_SUCCESS,
    GET_UNREAD_NOTIFICATIONS_FAIL,
    GET_RECENT_NOTIFICATIONS_REQUEST,
    GET_RECENT_NOTIFICATIONS_SUCCESS,
    GET_RECENT_NOTIFICATIONS_FAIL,
    GET_UNREAD_COUNT_REQUEST,
    GET_UNREAD_COUNT_SUCCESS,
    GET_UNREAD_COUNT_FAIL,
    MARK_NOTIFICATION_AS_READ_SUCCESS,
    MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS
} from '../actions/notificationActions';

const initialState = {
    unreadNotifications: [],
    unreadCount: 0,
    loading: false,
    error: null
};

function notificationReducer(state = initialState, action) {
    switch (action.type) {
        case GET_UNREAD_NOTIFICATIONS_REQUEST:
        case GET_RECENT_NOTIFICATIONS_REQUEST:
        case GET_UNREAD_COUNT_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_UNREAD_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.payload,
                loading: false
            };

        case GET_RECENT_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.payload, // We'll use this list for the top bar
                loading: false
            };

        case GET_UNREAD_COUNT_SUCCESS:
            return {
                ...state,
                unreadCount: action.payload,
                loading: false
            };

        case MARK_NOTIFICATION_AS_READ_SUCCESS:
            const updatedNotifs = state.unreadNotifications.map(n => 
                n.id === action.payload.id ? { ...n, read: true } : n
            );
            return {
                ...state,
                unreadNotifications: updatedNotifs,
                unreadCount: Math.max(0, state.unreadCount - 1)
            };

        case MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS:
            return {
                ...state,
                unreadNotifications: state.unreadNotifications.map(n => ({ ...n, read: true })),
                unreadCount: 0
            };

        case GET_UNREAD_NOTIFICATIONS_FAIL:
        case GET_RECENT_NOTIFICATIONS_FAIL:
        case GET_UNREAD_COUNT_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default notificationReducer;
